/**
 * Shared page-wrapper class strings, so page insets stay consistent and can be
 * tuned from one place. Bootstrap utilities only (per AGENTS.md) — these are
 * just the repeated wrapper strings extracted into named constants.
 */

/** Responsive horizontal page inset — tighter on phones, roomier from tablet up. */
const INSET_X = 'px-3 px-md-4 px-lg-5';

/** Standard page wrapper: centered container with top + bottom inset. */
export const PAGE_WRAPPER = `container my-4 my-lg-5 ${INSET_X}`;

/** Tabbed-page chrome (the tab/pill bar): top inset only. */
export const PAGE_WRAPPER_CHROME = `container mt-4 mt-lg-5 ${INSET_X}`;

/** Content rendered beneath tabbed chrome: bottom inset only. */
export const PAGE_WRAPPER_CONTENT = `container mb-4 mb-lg-5 ${INSET_X}`;
